
import NormalButton from "./NormalButton";

export default {

    NormalButton,

}